// eslint-disable-next-line no-unused-vars
import { createContext, useState, useEffect } from 'react'

import itemInfo from '../data/Items/itemInfo.json'

import { allowedMonsters } from '../data/Monsters/allowedMonsters.js'

import { isEnchantSlot } from '../data/Items/enchants'

import jobBaseHpJSON from '../data/Player/job_basepoints_HP.json'
import jobBaseSpJSON from '../data/Player/job_basepoints_SP.json'

import {
	bonusRegex,
	autobonusRegex,
	transpileVariables,
} from '../data/Items/NoaScript'

export const DBContext = createContext()
export class Slot {
	constructor() {
		//Type = Card, Enchant, None
		this.Type = 'None'
		this.isUsed = false
		this.ID = 0
		this.AegisName = '0'
		this.Script = ''
	}
	// changeSlot(type, id) {
	// 	this.Type = type
	// 	this.ID = id
	// 	if (this.ID === 0) this.isUsed = false
	// 	else this.isUsed = true
	// 	if (type === 'Card') {
	// 		let newCard = item_db_cardJSON.find(
	// 			(card) => card.Id === Number(id),
	// 		)
	// 		this.Script = newCard?.Script ? newCard.Script : ''
	// 		this.AegisName = id === 0 ? '0' : newCard.AegisName
	// 	}
	// 	if (type === 'Enchant') {
	// 		let newEnchant = item_db_enchantJSON.find(
	// 			(card) => card.Id === Number(id),
	// 		)
	// 		this.Script = newEnchant?.Script ? newEnchant.Script : ''
	// 		this.AegisName = id === 0 ? '0' : newEnchant.AegisName
	// 	}
	// }
	changeSlot(newCardEnchant) {
		this.Type = newCardEnchant.Type
		if (newCardEnchant.SubType === 'Enchant')
			this.Type = newCardEnchant.SubType
		this.ID = newCardEnchant.ID
		//for some reason in DB and local storage use diffent case for ID
		if (newCardEnchant.Id) this.ID = newCardEnchant.Id
		this.isUsed = this.ID !== 0
		this.Script = newCardEnchant?.Script ? newCardEnchant.Script : ''
		this.AegisName = newCardEnchant.AegisName
	}
	changeType(type) {
		this.Type = type
	}
}
export class Item {
	constructor(Location, isRefinable) {
		this.Id = 0
		this.AegisName = '0'
		this.Type = 0
		this.SubType = Location === 'Right_Hand' ? 'Fist' : 0
		this.Attack = 0
		this.MagicAttack = 0
		this.Defense = 0
		this.Range = 0
		this.Slots = 0
		this.Weight = 0
		this.Script = 0
		this.WeaponLevel = 0
		this.ArmorLevel = 0
		this.isRefinable = isRefinable
		this.Location = Location
		this.CardSlots = [new Slot(), new Slot(), new Slot(), new Slot()]
		this.refine = 0
	}
	setItem(dbItem) {
		this.Id = dbItem.Id
		this.AegisName = dbItem.AegisName
		this.Type = dbItem.Type
		this.SubType = dbItem.SubType
		this.Attack = dbItem.Attack
		this.MagicAttack = dbItem.MagicAttack
		this.Defense = dbItem.Defense
		this.Range = dbItem.Range
		this.Slots = dbItem.Slots
		this.Weight = dbItem.Weight
		this.Script = dbItem.Script
		this.WeaponLevel = dbItem.WeaponLevel
		this.ArmorLevel = dbItem.ArmorLevel
		this.CardSlots.map(
			(cardslot, index) =>
				(cardslot.Type =
					this.Slots > index
						? 'Card'
						: isEnchantSlot(dbItem.Id, index)
							? 'Enchant'
							: 'None'),
		)
	}
	setRefine(refine) {
		this.refine = refine
	}
}
export class Character {
	constructor(Stats, job, Blv, Jlv, Inventory) {
		this.Stats = {
			str: Stats.baseSTR ? Stats.baseSTR : 1,
			agi: Stats.baseAGI ? Stats.baseAGI : 1,
			vit: Stats.baseVIT ? Stats.baseVIT : 1,
			int: Stats.baseINT ? Stats.baseINT : 1,
			dex: Stats.baseDEX ? Stats.baseDEX : 1,
			luk: Stats.baseLUK ? Stats.baseLUK : 1,
		}
		this.Job = job ? job : 0
		this.BaseLevel = Blv ? Blv : 1
		this.JobLevel = Jlv ? Jlv : 1
		this.Inventory = Inventory
			? Inventory
			: {
					Head_Top: new Item('Head_Top', true),
					Head_Mid: new Item('Head_Mid', false),
					Head_Low: new Item('Head_Low', false),
					Armor: new Item('Armor', true),
					Right_Hand: new Item('Right_Hand', true),
					Left_Hand: new Item('Left_Hand', true),
					Garment: new Item('Garment', true),
					Shoes: new Item('Shoes', true),
					Right_Accessory: new Item('Right_Accessory', false),
					Left_Accessory: new Item('Left_Accessory', false),
					Shadow_Weapon: new Item('Shadow_Weapon', true),
					Shadow_Shield: new Item('Shadow_Shield', true),
					Shadow_Armor: new Item('Shadow_Armor', true),
					Shadow_Shoes: new Item('Shadow_Shoes', true),
					Shadow_Right_Accessory: new Item(
						'Shadow_Right_Accessory',
						true,
					),
					Shadow_Left_Accessory: new Item(
						'Shadow_Left_Accessory',
						true,
					),
				}
	}
}
export const DBProvider = ({ children }) => {
	//constant DB
	// const [item_db_equip] = useState(filterDB3(item_db_equipJSON, itemInfo))
	// const [itemDBEquipReady, setItemDBEquipReady] = useState(false)
	const [currentJob, setCurrentJob] = useState(0)
	const [item_db_equip, setItem_db_equip] = useState([])
	const [item_db_card, setItem_db_card] = useState([])
	const [item_db_enchant, setItem_db_enchant] = useState([])
	const [item_combos, setItem_combos] = useState([])
	const [item_ammo, setItem_ammo] = useState([])
	const [monster_db, setMonster_db] = useState([])
	const [monster_dbReady, setmonster_dbReady] = useState(false)
	const [jobBaseHp] = useState(jobBaseHpJSON)
	const [jobBaseSp] = useState(jobBaseSpJSON)
	const [lastSelectedItem, setLastSelectedItem] = useState(Number(0))
	const changeLastSelectedItem = (id) => {
		setLastSelectedItem(Number(id))
	}
	// const url = 'http://localhost:4000'
	const url = 'https://roprime-v2-backend.vercel.app'
	const [isDbRefreshed, setIsDbRefreshed] = useState(false)
	const refreshItemDb = async () => {
		try {
			fetch(url + '/api/items/class/' + currentJob)
				.then((itemsList) => itemsList.json())
				.then((items) => {
					filterDB(items)
					setIsDbRefreshed(true)
				})
		} catch (e) {
			console.log(e)
		}
	}

	useEffect(() => {
		setIsDbRefreshed(false)
		refreshItemDb()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentJob])

	try {
		useEffect(() => {
			fetchList(url + '/api/items/cards').then((resp) => {
				setItem_db_card(parseDB(resp.sort(compare)))
			})
			fetchList(url + '/api/items/enchants').then((resp) => {
				setItem_db_enchant(parseDB(resp.sort(compare)))
			})
			fetchList(url + '/api/items/combos').then((resp) => {
				setItem_combos(parseDB(resp))
			})
			fetchList(url + '/api/items/etc/ammo').then((resp) => {
				setItem_ammo(parseDB(resp))
			})
			fetchList(url + '/api/monsters/').then((resp) => {
				setMonster_db(
					resp
						.sort(compare)
						.filter((monster) =>
							allowedMonsters.includes(monster.Id),
						),
				)
				setmonster_dbReady(true)
			})
		}, [])
	} catch (e) {
		console.log(e)
	}
	function filterDB(rawDB) {
		setItem_db_equip(parseDB(filterDB3(rawDB, itemInfo)))
	}

	return (
		<DBContext.Provider
			value={{
				//DB
				item_db_equip,
				// itemDBEquipReady,
				setItem_db_equip,
				filterDB,
				// item_db_etc,
				item_db_card,
				item_db_enchant,
				item_combos,
				item_ammo,
				monster_db,
				monster_dbReady,
				lastSelectedItem,
				changeLastSelectedItem,
				Item,
				jobBaseHp,
				jobBaseSp,
				setCurrentJob,
				isDbRefreshed,
				setIsDbRefreshed,
				refreshItemDb,
			}}
		>
			{children}
		</DBContext.Provider>
	)
}

export async function fetchList(URL) {
	let ret
	const response = await fetch(URL)
	await response.json().then((texte) => (ret = texte))

	return ret
}

//for tests purposes, no filter
// function filterDB2(DB, itemInfo) {
// 	let newDB = []
// 	// eslint-disable-next-line array-callback-return
// 	DB.map((itm) => {
// 		if (itemInfo[itm.Id] !== undefined) {
// 			let newItem = itm
// 			if (
// 				itemInfo[itm.Id].identifiedDisplayName !== '(null)' &&
// 				itemInfo[itm.Id].identifiedDisplayName !== undefined &&
// 				itemInfo[itm.Id].identifiedDisplayName !== ' '
// 			) {
// 				newItem.Name = itemInfo[itm.Id].identifiedDisplayName
// 				newDB.push(newItem)
// 			}
// 		} else {
// 			let newItem = itm
// 			newDB.push(newItem)
// 		}
// 	})
// 	// console.log(newDB)
// 	return newDB.sort(compare)
// }
//manually filtered items
function filterDB3(DB, itemInfo) {
	// console.log(allowedItems)
	let newDB = []
	// eslint-disable-next-line array-callback-return
	DB.map((itm) => {
		// if (allowedItems.includes(itm.Id)) {

		try {
			let newItem = itm
			newItem.Name = itemInfo[itm.Id].identifiedDisplayName
			newDB.push(newItem)
		} catch {
			console.log(itm)
		}

		// }
	})
	return newDB.sort(compare)
}

function parseDB(db) {
	let parsedDB = []

	// eslint-disable-next-line array-callback-return
	db.map((itm) => {
		let newItem = itm
		newItem.Script = itm.Script?.replace(/(RC_[^,;]+)/g, '"$1"')
			.replace(/(RC2_[^,;]+)/g, '"$1"')
			.replace(/(Ele_[^,;]+)/g, '"$1"')
			.replace(/(Eff_[^,;]+)/g, '"$1"')
			.replace(/(Class_[^,;]+)/g, '"$1"')
			.replace(/(Size_[^,;]+)/g, '"$1"')
			.replace(/(hateffect[^;]+)/g, '') //removed hateffect because of parsing errors
			// .replace(/,(pow)/g, ',Math.$1')
			// .replace(/ (pow)/g, ' Math.$1') //added in case of pow not right after a coma
			// .replace(/\((pow)/g, '(Math.$1')//added in case of pow not right after a parenthesis
			// .replace(/,(min)/g, ',Math.$1')
			// .replace(/ (min)/g, ' Math.$1') //
			// .replace(/\((min)/g, '(Math.$1') //
			// .replace(/,(max)/g, ',Math.$1')
			// .replace(/ (max)/g, ' Math.$1') //
			// .replace(/\((max)/g, '(Math.$1') //
			// .replace(/(floor)/g, 'Math.$1')
			.replace(/Job_([^,; )]+)/g, '"$1"')
			.replace(/(PETINFO_EGGID)/g, '"$1"')
			.replace(/(IG_Jewel)/g, '"$1"')
			.replace(/(IG_Ore)/g, '"$1"')
			.replace(/(IG_Potion)/g, '"$1"')
			.replace(/(IG_Fish)/g, '"$1"')
			.replace(/(IG_Meat)/g, '"$1"')
			.replace(/(IG_Candy)/g, '"$1"')
			.replace(/(DT_MONTH)/g, '"$1"')
			// .replace(/(\(\.@r\/)/g, 'Math.floor$1')
			.replace(/(\(\.@r\/)/g, 'floor$1')

		parsedDB.push(newItem)
	})
	return parsedDB
}

function compare(a, b) {
	if (a.Name < b.Name) {
		return -1
	}
	if (a.Name > b.Name) {
		return 1
	}
	return 0
}

//Tests
// eslint-disable-next-line no-unused-vars
function testScript(db) {
	// eslint-disable-next-line array-callback-return
	db.map((item_db, index) => {
		console.log('item ' + (index + 1) + '/' + db.length)
		console.log(scriptParser(item_db.Script))
	})
}
function scriptParser(rawScript) {
	// console.log(rawScript)
	// let script = rawScript.toString().split('\n')
	let script = rawScript ? rawScript.toString().split('\n') : ''

	// let i = 5
	for (let i = 0; i < script.length; i++) {
		let temp = script[i].split(' ')

		for (let j = 0; j < temp.length; j++) {
			//get rid of indentation
			if (temp[j] !== '') {
				if (temp[j] === 'bonus') {
					script[i] = bonusRegex('bonus', script[i])
				}
				if (temp[j] === 'bonus2') {
					script[i] = bonusRegex('bonus2', script[i])
				}
				if (temp[j] === 'bonus3') {
					script[i] = bonusRegex('bonus3', script[i])
				}
				if (temp[j] === 'bonus4') {
					script[i] = bonusRegex('bonus4', script[i])
				}
				if (temp[j] === 'bonus5') {
					script[i] = bonusRegex('bonus5', script[i])
				}

				if (temp[j] === 'autobonus') {
					script[i] = autobonusRegex('autobonus', script[i])
				}
				if (temp[j] === 'autobonus2') {
					script[i] = autobonusRegex('autobonus2', script[i])
				}
				if (temp[j] === 'autobonus3') {
					script[i] = autobonusRegex('autobonus3', script[i])
				}
				if (temp[j] === 'skill') {
					script[i] = autobonusRegex('skill', script[i])
				}
				j = temp.length
			}
		}
	}
	if (script.length > 0) script = script.join('\n')
	script = transpileVariables(script)
	return script
}
